

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MwcNoAnimationDirective } from './mwc-no-animation.directive';

@NgModule({
  declarations: [MwcNoAnimationDirective],
  exports: [MwcNoAnimationDirective],
  imports: [CommonModule]
})
export class MwcNoAnimationModule {}
